module.exports = __webpack_public_path__ + "img/copy.1add274e.svg";